document.addEventListener("DOMContentLoaded", () => {
  // =====================================================
  // Helpers
  // =====================================================

  const EXTERNAL_WARNING =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  // =====================================================
  // External Link Warnings
  // =====================================================

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach((link) => {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";
        if (!alt.includes(EXTERNAL_WARNING)) {
          img.setAttribute(
            "alt",
            alt ? alt + ", " + EXTERNAL_WARNING : EXTERNAL_WARNING,
          );
        }
        return;
      }

      const text = link.textContent.trim();
      if (!text) return;

      const aria = link.getAttribute("aria-label");
      if (!aria || !aria.includes(EXTERNAL_WARNING)) {
        link.setAttribute("aria-label", text + ", " + EXTERNAL_WARNING);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =====================================================
  // Cart Accessibility
  // =====================================================

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    const cartClose = document.querySelector(".cart-close");
    if (!(cartClose instanceof HTMLElement)) return;

    cartClose.click();
  });

  document.addEventListener("click", (e) => {
    if (!(e.target instanceof Element)) return;

    // Cart opened -> focus close button
    if (e.target.closest(".header-cart-button")) {
      setTimeout(() => {
        const cartCloseBtn = document.querySelector(".cart-close");
        if (cartCloseBtn instanceof HTMLElement) cartCloseBtn.focus();
      }, 100);
    }

    // Cart closed -> focus back to header cart button
    if (e.target.closest(".cart-close")) {
      setTimeout(() => {
        const headerCartBtn = document.querySelector(".header-cart-button");
        if (headerCartBtn instanceof HTMLElement) {
          headerCartBtn.focus({ preventScroll: true });
        }
      }, 100);
    }
  });

  // =====================================================
  // Back to Top
  // =====================================================

  const backToTopButton = document.getElementById("back-to-top");
  if (backToTopButton) {
    window.addEventListener("scroll", () => {
      backToTopButton.style.display =
        window.pageYOffset > 300 ? "block" : "none";
    });

    backToTopButton.addEventListener("click", (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        const headerLink = document.getElementById("backtoheader");
        if (headerLink instanceof HTMLElement) headerLink.focus();
      }, 600);
    });
  }

  function updateDesktopClass() {
    document.querySelectorAll(".main_nav__link-items").forEach((element) => {
      if (window.matchMedia("(min-width: 1025px)").matches) {
        element.classList.add("desktop-only");
      } else {
        element.classList.add("mobile-only");
      }
    });
  }

  updateDesktopClass();
  window.addEventListener("resize", updateDesktopClass);
  // Convert menu links into buttons

  document
    .querySelectorAll(
      ".desktop-only ul.nav-item__primary-list li.has-children > a, .mobile-only ul.nav-item__primary-list li.has-children > a",
    )
    .forEach((link) => {
      link.removeAttribute("href");
      link.setAttribute("role", "button");
      link.setAttribute("tabindex", "0");
      link.setAttribute("aria-expanded", "false");
    });

  document
    .querySelectorAll(
      ".mobile-only ul.nav-item__primary-list li.has-children .mega-menu",
    )
    .forEach((menu) => {
      menu.setAttribute("role", "dialog");
      menu.setAttribute("aria-modal", "true");
      menu.setAttribute("tabindex", "0");
    });

  (function () {
    "use strict";

    const DESKTOP_WIDTH = 1025;

    function syncAriaExpanded() {
      document
        .querySelectorAll("[data-sublink-toggle]")
        .forEach(function (trigger) {
          trigger.setAttribute(
            "aria-expanded",
            trigger.classList.contains("active") ? "true" : "false",
          );
        });

      document
        .querySelectorAll("[data-toggle-mobile-menu]")
        .forEach(function (btn) {
          btn.setAttribute(
            "aria-expanded",
            document.body.classList.contains("mobile-menu--is-open")
              ? "true"
              : "false",
          );
        });
    }

    function closeDesktopMenus() {
      document
        .querySelectorAll("[data-sublink-toggle].active")
        .forEach(function (trigger) {
          trigger.classList.remove("active");
          trigger.setAttribute("aria-expanded", "false");
        });

      document
        .querySelectorAll("[data-mega-menu-id].active")
        .forEach(function (menu) {
          menu.classList.remove("active");
        });
    }

    function closeOtherDesktopMenus(currentTrigger) {
      document
        .querySelectorAll("[data-sublink-toggle].active")
        .forEach(function (trigger) {
          if (trigger !== currentTrigger) {
            trigger.classList.remove("active");
            trigger.setAttribute("aria-expanded", "false");
          }
        });

      document
        .querySelectorAll("[data-mega-menu-id].active")
        .forEach(function (menu) {
          const menuId = currentTrigger.getAttribute("data-sublink-toggle");

          if (!menuId || menu.id !== menuId) {
            menu.classList.remove("active");
          }
        });
    }

    function closeMobileMenu() {
      if (!document.body.classList.contains("mobile-menu--is-open")) {
        return;
      }

      const closeBtn = document.querySelector("[data-presented-close-menu]");

      if (closeBtn) {
        closeBtn.click();
      } else {
        document.body.classList.remove("mobile-menu--is-open");
      }

      syncAriaExpanded();
    }

    /* DESKTOP MENU CLICK */

    document.addEventListener(
      "click",
      function (e) {
        if (window.innerWidth <= DESKTOP_WIDTH) {
          return;
        }

        const trigger = e.target.closest("[data-sublink-toggle]");

        if (!trigger) {
          return;
        }

        const menuId = trigger.getAttribute("data-sublink-toggle");
        const menu = menuId ? document.getElementById(menuId) : null;

        const isOpen = trigger.classList.contains("active");

        /*
         * SAME OPEN MENU
         * Close it
         */
        if (isOpen) {
          trigger.classList.remove("active");
          trigger.setAttribute("aria-expanded", "false");

          if (menu) {
            menu.classList.remove("active");
          }

          return;
        }

        /*
         * DIFFERENT MENU
         * Close previously opened menu
         */
        closeOtherDesktopMenus(trigger);

        /*
         * Allow the theme to open the clicked menu.
         *
         * We do NOT manually add active here because
         * the theme already controls the opening.
         */
        setTimeout(function () {
          syncAriaExpanded();
        }, 0);
      },
      true,
    );

    /* ESCAPE */

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") {
        return;
      }

      if (window.innerWidth > DESKTOP_WIDTH) {
        closeDesktopMenus();
      } else {
        closeMobileMenu();
      }

      syncAriaExpanded();
    });

    /* OUTSIDE CLICK */

    document.addEventListener("click", function (e) {
      if (window.innerWidth <= DESKTOP_WIDTH) {
        return;
      }

      if (
        !e.target.closest(".main_nav__link-items") &&
        !e.target.closest("[data-mega-menu-id]")
      ) {
        closeDesktopMenus();
        syncAriaExpanded();
      }
    });

    /* CLOSE DESKTOP MENU ON SCROLL */

    window.addEventListener("scroll", function () {
      if (window.innerWidth > DESKTOP_WIDTH) {
        closeDesktopMenus();
        syncAriaExpanded();
      }
    });

    /* KEEP ARIA-EXPANDED IN SYNC */

    const observer = new MutationObserver(function () {
      syncAriaExpanded();
    });

    window.addEventListener("load", function () {
      syncAriaExpanded();

      document
        .querySelectorAll("[data-sublink-toggle], [data-toggle-mobile-menu]")
        .forEach(function (el) {
          observer.observe(el, {
            attributes: true,
            attributeFilter: ["class"],
          });
        });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  })();
});
